import React,  { useState } from 'react'
import { storyboard__experience } from '../../../i18n/text/data'

const Experience = () => {
    const [menu, showMenu] = useState(true)
    const toggle = (e) => {
        showMenu(!menu)
    }
    const [header, setHeader] = useState(storyboard__experience[0].title)
    const [text, setText] = useState(storyboard__experience[0].content)
    const showContent = (id) => {
        setText(storyboard__experience[id].content)
        setHeader(storyboard__experience[id].title)
        toggle()
    }
    const menuItems = storyboard__experience.map((item) => <div key={item.id} className="story__section_description" onClick={() => showContent(item.id)}>{item.title}</div>)
    const content = text.map((line) => <p className="story__section_text--panel"> {line}</p>)
    
    return (
    <div className="story__section">
    <div className="story__board">
        <div 
        className="story__board_toggle"
            onClick={(e) => toggle(e)}>
                {menu? <span class="material-icons icon--large openMenu">change_history</span> : <span class="material-icons icon--large closeMenu">change_history</span>}
        </div>
        {
            menu ?
            <div className="story__board_menu" >
                {menuItems}
            </div>
            :                        
            <div className="story__board_content">
                <p className="header">{header}</p>
                {content}
            </div>
        }  
    </div>
</div>
)
}

export default Experience
